namespace GeniuzPOS.Administration {
    export class PsParaColumns {
        static columnsKey = 'Administration.PsPara';
    }
}
